import { Fonts, Spacings } from '@styles/index';
import styled from '@emotion/styled';
import { useRouter } from 'next/router';
import P1 from '@base/P1/P1';
import Button from '@base/Button/Button';
import useOneLinkSmartScript from '@hooks/useOneLinkSmartScript';
import Image from '@base/Image';
import { segment } from '@actions/analytics';
import {
  FREE_TRIAL_DOWNLOAD_APP_CLICKED,
  FREE_TRIAL_GO_TO_HOME_CLICKED
} from './constants/segment';
import GoalCard from './GoalCard';

const HR = styled.hr`
  border-top: 1px solid var(--color-divider);
`;

const Wrapper = styled.div`
  max-width: 500px;
  margin: auto;
  padding: ${Spacings.SPACING_8B} ${Spacings.SPACING_4B};
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Heading = styled.div`
  font-size: 22px;
  font-weight: ${Fonts.HEAVY};
  margin-top: ${Spacings.SPACING_6B};
  margin-bottom: ${Spacings.SPACING_1B};
  color: var(--color-text-primary);
`;

const Description = styled(P1)`
  margin-bottom: ${Spacings.SPACING_6B};
  text-align: center;
  color: var(--color-text-secondary);
`;

const StyButton = styled(Button)`
  margin-top: ${Spacings.SPACING_6B};
`;

const TrialActive = ({
  goal,
  grantResponse,
  referralCode,
  isAlreadyActive
}) => {
  const router = useRouter();
  const { inside_app } = router.query;
  const finalDownloadLink = useOneLinkSmartScript();
  const { name, icon } = goal;

  const downloadApp = () => {
    if (inside_app) {
      window.open(
        `${goal.relativeLink}/subscribe?navigation_reset=true`,
        '_blank'
      );
      segment.track(FREE_TRIAL_GO_TO_HOME_CLICKED, {
        free_trial_source: referralCode
      });
    } else {
      window.open(finalDownloadLink, '_blank');
      segment.track(FREE_TRIAL_DOWNLOAD_APP_CLICKED, {
        free_trial_source: referralCode
      });
    }
  };

  return (
    <>
      <HR />
      <Wrapper>
        <Image
          src="/free-trial/status.svg"
          alt="status"
          width="120"
          height="120"
        />
        <Heading>
          {isAlreadyActive
            ? 'Your free trial is already active'
            : 'Your free trial is active'}
        </Heading>
        <Description>
          {isAlreadyActive
            ? 'Continue your fully featured learning experience on the Unacademy app'
            : 'Start learning on the app to experience your free trial with planner, tests, live classes and more...'}
        </Description>
        <GoalCard
          name={name}
          icon={icon}
          endDate={grantResponse?.subscription_end_date}
        />
        <StyButton
          onClick={downloadApp}
          label={inside_app ? 'Go To Home' : 'Download the app'}
          width="100%"
          color="black"
        />
      </Wrapper>
    </>
  );
};

export default TrialActive;
